import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/cid";

/**
 * Classe de gerenciamento de chamadas da API dos CID´s
 *
 * @class
 */
export default class CidApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe CidApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns Lista CID
   */
    listar(codGuia: number) {

        return this.api<ApplicationModule[]>(`${controller}/listar`, {
            method: "GET",
            params: { codGuia }
        });
    }

    /**
   * @returns LerRegistro CID
   */
    lerRegistro(codCid: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codCid }
        });
    }
}